var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBfidOpenClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8939 16.6835C14.9248 17.6526 13.7318 18.3677 12.4203 18.7655C11.1089 19.1633 9.71964 19.2315 8.37555 18.9642C7.03146 18.6968 5.77405 18.1021 4.71469 17.2327C3.65534 16.3633 2.82675 15.2461 2.30231 13.98C1.77787 12.7139 1.57377 11.338 1.7081 9.97417C1.84242 8.61034 2.31102 7.30069 3.07239 6.16122C3.83376 5.02176 4.86439 4.08764 6.073 3.44163C7.28161 2.79562 8.63088 2.45764 10.0013 2.45764",
    stroke: "#E4E4E4",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.45764C11.6482 2.45764 13.2593 2.94638 14.6298 3.86206C16.0002 4.77774 17.0683 6.07923 17.699 7.60195C18.3297 9.12466 18.4948 10.8002 18.1732 12.4167C17.8517 14.0332 17.058 15.5181 15.8926 16.6835",
    stroke: "#E4E4E4",
    strokeWidth: 2,
    strokeDasharray: "3 3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4117 13.441L9.82839 11.8993C9.37839 11.6326 9.01172 10.991 9.01172 10.466V7.04932",
    stroke: "#E4E4E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidOpenClock);
export default __webpack_public_path__ + "static/media/bfid-open-clock.becc9315c01faaea02bc0a60d745c540.svg";
export { ForwardRef as ReactComponent };